import moment from 'moment'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PatientVisitTag } from 'ui_kit_qmd'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getAge, isActiveEllipsisCheck, parseTimeZone, parseUserDateTime } from '../../../../../utils/common'
import './PatientInfoCard.scss'
import { PatientInfoCardRows } from '../PatientInfoCardRows/PatientInfoCardRows'
import {
  DOB,
  CHARTS_MRN_SORT_CONDITION,
  PROVIDER,
  STATUS_TEXT,
  VISIT_DATE_TIME,
  MAT_MOUD_TEXT,
} from '../../../../../utils/constants'
import { generateVisitTableRowStatus } from '../../../../../utils/VisitsCommon'
import { ProgramVisitBadge } from 'components/program-visit-badge/ProgramVisitBadge'
import { GrantVisitBadge } from 'components/grant-visit-badge/GrantVisitBadge'
import { readVisitCoverage } from '@quickmd-llc/frontend-utils'

const patientChartToolTipPopUpStyle = {
  top: '90%',
  left: '0%',
}

type Props = {
  /** Only the name parts are read — the chart's provider payload carries no id here. */
  providerInfo?: { Prefix?: string; FirstName?: string; LastName?: string; Suffix?: string }
  visitId: string
  isUpcomingVisit?: boolean
}

export const PatientInfoCard = memo(({ providerInfo, visitId, isUpcomingVisit }: Props) => {
  const params = new URLSearchParams(window.location.search)
  const location = useLocation()

  const patientId = location.state?.patientId || params.get('patientId')

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  const timeZone = parseTimeZone(profile.TimeZone)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const visitInfo = useSelector((state) => state.chartsReducer.visitInfo[visitId])
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const pastVisits = useSelector((state) => state.chartsReducer.pastVisits)

  const [isShowNamesPopUp, setIsShowNamesPopUp] = useState(false)
  const [isOnHoverShowNamesPopUp, setIsOnHoverShowNamesPopUp] = useState(false)

  const patientInfoConfig = useMemo(
    () => [
      [
        {
          key: `${DOB}:`,
          value: moment(patientInfo?.[patientId]?.BirthDate).format('MM/DD/YYYY'),
        },
        {
          key: `${CHARTS_MRN_SORT_CONDITION}:`,
          value: patientInfo?.[patientId]?.MedicalRecordNumber,
        },
      ],
      {
        key: `${VISIT_DATE_TIME}:`,
        value: parseUserDateTime(moment(visitInfo?.FromDateTime), timeZone, true),
      },
      {
        key: `${PROVIDER}:`,
        value: `${providerInfo?.Prefix ? `${providerInfo?.Prefix} ` : ''}${providerInfo?.FirstName} ${
          providerInfo?.LastName
        }${providerInfo?.Suffix ? ` ${providerInfo?.Suffix}` : ''}`,
      },
      [
        {
          id: 'patient-info-card-visit-type-name',
          visitType: visitInfo?.Method,
          value: visitInfo?.VisitTypeName,
        },
        {
          className: 'patient-info-card-mat-moud',
          value: visitInfo.IsMedicationAssistedTreatment && MAT_MOUD_TEXT,
        },
        {
          key: `${STATUS_TEXT}:`,

          value: generateVisitTableRowStatus(visitInfo?.Status),
        },
      ],
    ],
    [patientInfo, visitInfo, providerInfo, pastVisits, timeZone],
  )

  useEffect(() => {
    const timer = setInterval(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      isActiveEllipsisCheck('PatientInfoCardFirstLastName', setIsShowNamesPopUp)
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const onMouseOverName = () => {
    setIsOnHoverShowNamesPopUp(true)
  }

  const onMouseLeaveName = () => {
    setIsOnHoverShowNamesPopUp(false)
  }

  return (
    <div className='patient-info-card-main-wrapper'>
      <div className='patient-info-card-name-wrapper'>
        <div
          id='PatientInfoCardFirstLastName'
          className='patient-info-card-name'
          onMouseLeave={onMouseLeaveName}
          onMouseOver={onMouseOverName}
          onFocus={() => {}}>
          <div />
          {patientInfo?.[patientId]?.FirstName} {patientInfo?.[patientId]?.LastName}
        </div>
        <div className='patient-info-card-gender-block'>
          ({patientInfo?.[patientId] ? getAge(moment(patientInfo?.[patientId]?.BirthDate).toString()) : null}/
          {patientInfo?.[patientId]?.Gender === 'male' ? 'M' : 'F'})
        </div>
        {isUpcomingVisit ?
          <PatientVisitTag
            className='patient-info-card-visit-tag'
            isNewForServiceType={visitInfo?.IsNewForServiceType}
            isNewForPatient={visitInfo?.IsNewForPatient}
          />
        : null}
        {/* Not gated on `isUpcomingVisit` — this component also serves the past-visit
            notes page, and `Position` is a fact about that visit either way. `ml-sp-1`
            matches the 8px margin the neighbouring tag and age block already use. */}
        <ProgramVisitBadge className='ml-sp-1 shrink-0 self-center' coverage={readVisitCoverage(visitInfo)} />
        {/* A grant funds the visit outright, so this chip is independent of the
            plan chip above — at most one of the two ever draws for a given visit. */}
        <GrantVisitBadge className='ml-sp-1 shrink-0 self-center' coverage={readVisitCoverage(visitInfo)} />
        {isOnHoverShowNamesPopUp && isShowNamesPopUp ?
          <div className='firstLastNameBlockChartTip' style={patientChartToolTipPopUpStyle}>
            {patientInfo?.[patientId]?.FirstName} {patientInfo?.[patientId]?.LastName}
          </div>
        : null}
      </div>
      {/*
       // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
      <PatientInfoCardRows infoConfig={patientInfoConfig} />
    </div>
  )
})
